import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICE_ICONS, SERVICE_SPANS } from "../config";
import { useLang } from "../LanguageContext";
import { Reveal, Eyebrow } from "./Reveal";

export const Services = () => {
  const { t } = useLang();
  const go = () => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="services" data-testid="services" className="relative py-24 md:py-32 bg-[#050505]">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="max-w-3xl mb-16">
          <Reveal><Eyebrow testId="services-eyebrow">{t.services.eyebrow}</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display text-4xl md:text-6xl text-white tracking-tight leading-[1.05]">
              {t.services.title1} <span className="text-gold-gradient italic">{t.services.title2}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-6 text-[#a3a3a3] text-base md:text-lg leading-relaxed max-w-xl">{t.services.subtitle}</p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 auto-rows-fr">
          {t.services.items.map((s, i) => {
            const Icon = SERVICE_ICONS[i];
            return (
              <motion.div
                key={i}
                data-testid={`service-card-${i}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: (i % 3) * 0.08 }}
                whileHover={{ scale: 1.015 }}
                onClick={go}
                className={`group cursor-pointer glass rounded-2xl p-8 md:p-10 relative overflow-hidden hover:border-[#d4af37]/40 transition-colors duration-500 ${SERVICE_SPANS[i]}`}
              >
                <div className="absolute -top-16 -right-16 w-40 h-40 rounded-full bg-[#d4af37]/0 group-hover:bg-[#d4af37]/10 blur-3xl transition-colors duration-500" />
                <div className="flex items-start justify-between">
                  <div className="w-14 h-14 rounded-xl glass flex items-center justify-center text-[#d4af37] group-hover:scale-110 transition-transform duration-500">
                    <Icon size={24} strokeWidth={1.5} />
                  </div>
                  <ArrowUpRight className="text-white/30 group-hover:text-[#d4af37] group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300" size={22} />
                </div>
                <div className="mt-8 text-[11px] tracking-[0.3em] uppercase text-[#d4af37]">{s.tag}</div>
                <h3 className="mt-2 font-display text-2xl md:text-3xl text-white">{s.title}</h3>
                <p className="mt-3 text-[#a3a3a3] leading-relaxed max-w-md">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
